import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Housebuilding from "./sections/Housebuilding";
import Earthworks from "./sections/Earthworks";
import Flooring from "./sections/Flooring";
import Kosztorysy from "./sections/Kosztorysy";
import Estimate from "./sections/Estimate";
import Kontakt from "./sections/Kontakt";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <Housebuilding />
      <Earthworks />
      <Flooring />
      <Kosztorysy />
      <Estimate />
      <Kontakt />
      <Footer />
    </div>;
}